import React from 'react'
import { HiChevronDown } from "react-icons/hi";

//components
import TextSmallButton from '../Button/Text/TextSmallButton';

function Footer() {
    return (
        <div>
            <div className='pt-125'>
                <div className='flex flex-row items-center px-165 py-75 w-screen bg-no-repeat bg-cover' style={{ backgroundImage: "url('https://ik.imagekit.io/xomvboztg/nbi-landing/Footer.svg?updatedAt=1737010724411')", backgroundRepeat: "no-repeat" }} >
                    <div className='flex flex-col w-full space-y-24'>
                        <div className='flex flex-row space-x-24 space-y-24 items-center '>
                            <div>
                                <img src="https://ik.imagekit.io/xomvboztg/nbi-landing/Logo.png?updatedAt=1736412031365" style={{ width: "79px" }} alt="NBI logo" />
                            </div>
                            <div className='flex flex-col text-white'>
                                <div className='text-16 font-bold'>
                                    National Bureau of Investigation
                                </div>
                                <div className='text-14 font-regular'>
                                    Electronic Payment and Collection System
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col'>
                            <div className='text-14 font-regular text-white'>
                                23-F Landmark Tower, Ayala Avenue, Bel-Air,
                            </div>
                            <div className='text-14 font-regular text-white'>
                                Makati, 1209 Metro Manila, Philippines.
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col text-right' style={{ width: "100%" }} >
                        <div className='text-14 font-regular text-white'>
                            For any concerns you may contact us at
                        </div>
                        <div className='text-23  font-bold text-white'>
                            09173456789 (Smart) or 09662345678 (Globe)
                        </div>
                        <div className='py-12'>
                            <hr />
                        </div>
                        <div className='text-14 font-regular text-white'>
                            *From 6 AM - 6 PM everyday except national public holidays and weekends.
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex justify-end items-center w-screen' style={{ backgroundColor: "#323232" }}>
                <div className='flex flex-row space-x-32 justify-ends items-center px-120 w-full'>
                    <div className='flex flex-row py-20 space-x-24 w-full'>
                        <div>
                            <TextSmallButton
                                name="PRIVACY POLICY"
                            />
                        </div>
                        <div>
                            <TextSmallButton
                                name="TERMS AND CONDITIONS"
                            />
                        </div>
                    </div>
                    <div>
                        <TextSmallButton
                            name="LANGUAGE"
                        />
                    </div>
                    <div className='text-white'>
                        |
                    </div>
                    <div className='flex flex-row space-x-8 justify-center items-center '>
                        <div className='w-20'>
                            <img src="https://ik.imagekit.io/xomvboztg/nbi-landing/ph-flag.png?updatedAt=1736401802703" alt="Philippine flag" />
                        </div>
                        <TextSmallButton
                            name="TAGALOG"
                            showTrailingIcon={<HiChevronDown />}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer